
import mitt from 'mitt';
import _ from "lodash";
import OpenIcon from "@/assets/icons/icons-burger-open.svg?inline";
import {Options, Vue} from 'vue-class-component';

const emitter = mitt();

@Options({
  components: {
    OpenIcon
  }
})
export default class FaqQuestion extends Vue {
  private FAQ_SELECTED_INDEX_KEY  = 'faqSelectedIndex';
  private showAnswer = false;
  private id: string = _.uniqueId("id");

  created() {
    emitter.on(this.FAQ_SELECTED_INDEX_KEY, (id) => {
      if (id !== this.id && this.showAnswer) {
        this.showAnswer = !this.showAnswer;
      }
    });
  }

  private showAnswerClick() {
    this.showAnswer = !this.showAnswer;
    emitter.emit(this.FAQ_SELECTED_INDEX_KEY, this.id);
  }
}
